import React from 'react';
import { motion } from 'framer-motion';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import PortfolioManagement from './components/PortfolioManagement';
import CryptoWatchlist from './components/CryptoWatchlist';
import BuySellSignals from './components/BuySellSignals';
import AIAgentDemo from './components/AIAgentDemo';
import MarketInsights from './components/MarketInsights';
import Footer from './components/Footer';
import { GradientProvider } from './components/GradientContext';
import GradientBackground from './components/GradientBackground';
import SubscriptionPlans from './components/SubscriptionPlans';

const App: React.FC = () => {
  return (
    <GradientProvider>
      <div className="app-container relative z-10">
        <GradientBackground />
        <Navbar />
        <main>
          <Hero />
          <PortfolioManagement />
          <CryptoWatchlist />
          <AIAgentDemo />
          <MarketInsights />
          <SubscriptionPlans />

        </main>
        <Footer />
      </div>
    </GradientProvider>
  );
};

export default App;
